import { render, staticRenderFns } from "./TurndownModal.vue?vue&type=template&id=354c9159&"
import script from "./TurndownModal.vue?vue&type=script&lang=js&"
export * from "./TurndownModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports